<template>
    <div :id="'MenuHorizontal-generico' + idMenu" class="menu-hrz-intranet container-fluid p-0">
        <nav class="navbar navbar-expand-md navbar-light bg-light">
            <a class="navbar-brand" href="javascript:void(0)" @click="irA">INTRANET</a>
            <div class="collapse navbar-collapse" id="navbarNavDropdown">
                <ul class="navbar-nav">
                    <!-- DESDE BASE DE DATOS -->
                    <li class="nav-item dropdown" v-for="(menu,index) in menus" :key="'menu' + index">
                        <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> {{ menu.Titulo }} </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                            <li class="dropdown-submenu" v-for="(submenu,index) in submenusPadreConPermisos({ submenus: menu.Submenus })" :key="'submenu' + index">
                                <a class="dropdown-item dropdown-toggle" href="#">{{ obtenerTituloOSubtituLoDeEnlace({ titulo: submenu.Titulo }) }}</a>
                                <ul class="dropdown-menu">
                                    <li v-for="(submenuHijo,index) in submenu.SubmenusQueMePertenecen" :key="'submenuHijo' + index">
                                        <a v-if="campoRequeridoEsValido(submenuHijo.RutaParaAccesar) && submenuHijo.RutaParaAccesar.includes('http')" class="dropdown-item" target="_blank" :href="submenuHijo.RutaParaAccesar">
                                            {{ obtenerTituloOSubtituLoDeEnlace({ titulo: submenuHijo.Titulo }) }}
                                        </a>
                                        <router-link v-else-if="campoRequeridoEsValido(submenuHijo.RutaParaAccesar)" class="dropdown-item" :to="submenuHijo.RutaParaAccesar + '/' + submenuHijo.Titulo.replace(/\s/g,'')">
                                            {{ obtenerTituloOSubtituLoDeEnlace({ titulo: submenuHijo.Titulo }) }}
                                        </router-link>
                                    </li>
                                </ul>
                            </li> 
                        </ul>
                    </li>
                     <!-- BARRA DE BUSQUEDA -->
                    <div id="barra-busqueda" class="d-flex align-items-center">
                        <div class="input-group">
                            <!-- v-on:keyup="buscarTexto(textoParaBusqueda,['A','H2','H3'])"  -->
                            <input v-model="textoParaBusqueda" v-on:keyup="buscarTexto(textoParaBusqueda,['A','H2','H3','H4'],'#contenedor-tarjetas')"  v-on:keyup.enter="indexSeleccionado=siguienteCoincidencia(indexSeleccionado)"   id="ac-desplegar-menu-busqueda" class="form-control input-sm input-xs input-md input-lg py-2 border-right-0 border" type="search" placeholder="Buscar">
                            <div class="input-group-append">
                                <!-- @click="buscarTexto(textoParaBusqueda,['A','H2','H3'])" -->
                                <div id="ac-desplegar-menu-busqueda-div" @click="indexSeleccionado=siguienteCoincidencia(indexSeleccionado)"   class="input-group-text"><i id="ac-desplegar-menu-busqueda-icono" class="fa fa-search"></i></div>
                                 <!-- <div id="ac-desplegar-menu-busqueda-div"   class="input-group-text"><i class="fas fa-arrow-right"></i></div> -->
                          
                            </div>
                        </div>
                    </div>
                </ul>
            </div>
        </nav>
      
    </div>
</template>
<script>
import router from '@/router/index'
import axios from 'axios'
import api from '@/../static/js/api'
import comun from "@/../static/js/comun"

export default {
    props: {
        idMenu: {
            type: String,
            default: 'MenuHorizontal-generico'
        },
    },
    data() {
        return {
            menus: [],
            textoParaBusqueda:"",
            listaNodos:[],
            indexSeleccionado:0,
            MENUS: {
                AREAS: 93 // DE MOMENTO EL UNICO MENU PRINCIPAL
            },
            PAGINA_INICIO_INTRANET: 11,
            menusConPermisos: [],
            obtuvoPermisos: false
        }
    },
    async created() {
        //await Promise.resolve(this.obtenerMenusConSubmenusDB());
    },
    watch: {
        '$store.state.Login_PermisosDelSistema': async function() {
            console.log('permisos::',this.$store.state.Login_PermisosDelSistema);
            if(this.campoRequeridoEsValido(this.$store.state.Login_PermisosDelSistema) && !this.obtuvoPermisos) {
                this.menusConPermisos = this.$store.state.Login_PermisosDelSistema.map(p => (p.Nombre));
                this.obtuvoPermisos = true;
                await Promise.resolve(this.obtenerMenusConSubmenusDB());
            }
        }
    },
    methods: {
        submenusPadreConPermisos: function({ submenus }) {
            let submenusConPermisos = submenus;
            if(this.campoRequeridoEsValido(this.menusConPermisos)) {
                submenusConPermisos = submenus.filter(sm => this.menusConPermisos.some(mCP => mCP.replace(/\s/g,'').toUpperCase() == this.obtenerTituloOSubtituLoDeEnlace({ titulo: sm.Titulo }).replace(/\s/g,'').toUpperCase()));
            }
            return submenusConPermisos;
        },
        obtenerMenusConSubmenusDB: async function() {
            let procesoSinError = false;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.paginaintranet.ObtenerMenusDeIntranet;
                const SERVICIO_REST = SERVIDOR + METODO_API_OBTENER;
                let peticion = { PaginaDeInicioId: this.PAGINA_INICIO_INTRANET, EsPrueba: false };
                let peticionArchivos = false;
                let HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                const RESPUESTA_PETICION = await axios.post(SERVICIO_REST, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_PETICION.data;
                let { SiHayError, Error, Menus } = DATOS_RESPUESTA;
                if (SiHayError) {
                    console.log(Error);
                } 
                else {
                    console.log('OBJETOS::MENUSSSS::',Menus);
                    this.menus = Menus;
                    procesoSinError = true;
                }
            }
            catch(excepcion) {
                console.log(excepcion);
            }
            return procesoSinError;
        },
        /**
         * Debido a que el campo titulo para los submenus requiere de cierta logica se almacena con un "-"
         * @param {String} titulo [nombre del submenu con complementos]
         * @returns {String} tituloValido [variable que representa el titulo del submenu sin complementos]
         */
        obtenerTituloOSubtituLoDeEnlace: function({ titulo }) {
            let tituloValido = titulo;
            if(this.campoRequeridoEsValido(titulo)) {
                const ELEMENTOS_DE_TITULO = titulo.split('-');
                if(this.campoRequeridoEsValido(ELEMENTOS_DE_TITULO))
                    tituloValido = ELEMENTOS_DE_TITULO[0];
            }
            return tituloValido;
        },
        irA: function() {
            router.push({ name: "Inicio" });
        },

        buscarTexto:function(textoBuscado,tiposElemento,elementoPadreParaBuscar){
            var listaDeNodos=[];
            if(textoBuscado=="") this.indexSeleccionado = 0;
            document.querySelector(elementoPadreParaBuscar).querySelectorAll('*').forEach(function(node){
                if(tiposElemento.indexOf(node.nodeName) != -1 && node.innerText.toUpperCase().includes(textoBuscado.toUpperCase())  && textoBuscado!=""){  
                        if(node.parentElement.style.display!='none'){   
                            node.style.backgroundColor ="#FFEC33";
                            listaDeNodos.push(node);
                        }                    
                }else if(tiposElemento.indexOf(node.nodeName) != -1){
                    node.removeAttribute("style");
                }else if(tiposElemento.indexOf(node.nodeName) != -1 && textoBuscado==""){
                    node.removeAttribute("style")
                } });
        
            this.listaNodos = listaDeNodos;
   },
        siguienteCoincidencia:function(numero){
            this.listaNodos.forEach(function(node,index){
             node.style.backgroundColor ="#FFEC33";
                if(index==numero){
                        node.style.backgroundColor ="#FFA833";
                        node.scrollIntoView();      
                }   
            });
            if(numero == this.listaNodos.length) numero=0; else numero++;   
        return numero
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'array' || campo instanceof Array) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo.length > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        }
    },
}
</script>
<style scoped>
.colorRojo{
    background-color: red !important;
}
.menu-hrz-intranet .navbar {
    background-color: rgb(58, 58, 58) !important;
}

.menu-hrz-intranet .navbar-brand {
    margin-right: 4%;
    color: white;
    font-weight: bold;
    font-size: 3.5vmin;
}

.menu-hrz-intranet .navbar-nav {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.menu-hrz-intranet .nav-link {
    color: white !important;
}

.menu-hrz-intranet .nav-link:hover, .menu-hrz-intranet .nav-link:focus {
    /* color: #be9a5e !important; */
    background-color: rgb(129, 129, 129);
}

.menu-hrz-intranet .dropdown-toggle {
    font-size: 1.6em;
}

.menu-hrz-intranet .dropdown-toggle::after {
    vertical-align: middle;
}

.menu-hrz-intranet .dropdown-menu {
    padding-top: 0;
    padding-bottom: 0;
}

/* .menu-hrz-intranet .bordes-menu .dropdown-item {
    border-bottom: 1px solid #4F4949;
    font-weight: bold;
    color: black;
} */

.menu-hrz-intranet .dropdown-item:focus, .menu-hrz-intranet .dropdown-item:hover {
    background-color: rgb(153, 152, 152) !important;
    color: white;
}

#icono-pj-intranet {
    width: 10vmin;
    height: 7vmin;
    cursor: pointer;

}

#barra-busqueda .form-control {
    background-color: white;
    color: rgb(63, 62, 62);
}

#barra-busqueda .input-group-text {
    background-color: white;
    color: rgb(63, 62, 62);
}

#ac-desplegar-menu-busqueda-div {
    /* background-color: #be9a5e !important; */
    background-color: black !important;
    border: 1px solid white
}

#ac-desplegar-menu-busqueda-icono {
    color: white;
}

#barra-busqueda i {
    cursor: pointer;
}

#ac-desplegar-menu-busqueda {
    width: 43vmin;
}

/* SUBMENU */
.menu-hrz-intranet .navbar-nav li:hover > ul.dropdown-menu {
    display: block;
}
.menu-hrz-intranet .dropdown-submenu {
    position:relative;
    font-size: 0.7em !important;
}
.menu-hrz-intranet .dropdown-submenu > .dropdown-menu {
    top: 0;
    left: 100%;
    margin-top:-5px;
}

.menu-hrz-intranet .dropdown-menu > li > a:hover:after {
    text-decoration: underline;
    transform: rotate(-90deg);
} 

 

</style>


// WEBPACK FOOTER //
// src/components/Intranet/Comun/CMenuHorizontal.vue